import React, { useState, useEffect } from 'react';
import { useData, useSettings, useStore } from '../context/store';
import useUpdateTerm from '../methods/useUpdateTerm';
import TaxonomyList from './TaxonomyList';

export default function SortBy() {
	const { state, dispatch } = useStore();

	const settings = useSettings();

	const DisplayCurrentTax = function () {
		const state = useData();

		const { updateTerm } = useUpdateTerm();

		if (Object.keys(state.taxonomies).length !== 0) {
			// console.log('tax ', state.taxonomies);
			{
				return state.taxonomies.map((taxonomy) => {
					// console.log('curent tax', taxonomy, taxonomy.terms);
					return taxonomy.terms.map((taxTerm, index) => {
						if (taxTerm.checked === true) {
							return (
								<div className="tf-main__pill" key={index}>
									<div dangerouslySetInnerHTML={{ __html: taxTerm.name }}></div>
									<span
										className="icon-cancel"
										onClick={(e) =>
											updateTerm(
												taxonomy.name,
												taxTerm.term_id,
												false
											)
										}
									></span>
								</div>
							);
						}
					});
				});
			}
		}
		return '';
	};

	if ('undefined' !== typeof state) {
		let resultsText = 'Trip Results';

		if (state.sortBy && 'date' == state.sortBy) {
			resultsText = 'Departure Dates';
		}

		return (
			<div className="tf-sort-by">
				<div className="tf-sidebar__count">
					Showing {state.postsCount} {resultsText}
				</div>
				<DisplayCurrentTax />
				{/* <div
					dangerouslySetInnerHTML={{ __html: displayCurrentTax() }}
				></div> */}

				<div className={`tf-sort-by__view-by ${state.sortBy}`}>
					<p className="subtitle-2 has-subtitle-2-font-size">
						View By
					</p>
					<button
						className="tf-sort-btn default"
						onClick={(e) => {
								dispatch({
									type: 'setCurrentPage',
									payload: 1,
								});
								dispatch({
									type: 'setSortBy',
									payload: 'default',
								});
							}
						}
					>
						Default
					</button>
					<button
						className="tf-sort-btn destination"
						onClick={(e) => {
								dispatch({
									type: 'setCurrentPage',
									payload: 1,
								});
								dispatch({
									type: 'setSortBy',
									payload: 'destination',
								});
							}
						}
					>
						Destination
					</button>
					<button
						className="tf-sort-btn date"
						onClick={(e) => {
								dispatch({
									type: 'setCurrentPage',
									payload: 1,
								});
								dispatch({
									type: 'setSortBy',
									payload: 'date',
								});
							}
						}
					>
						Date
					</button>
				</div>
			</div>
		);
	}
	return '';
}
